import React, { useState } from "react";
import { MdWeb } from "react-icons/md";
import { Link } from "react-router-dom";
import styled from "styled-components";
import PageHeader from "../../Elements/Header";
import IMAGEHEADER from "../../Assets/images/high-angle-globe-with-academic-cap-laptop.jpg";
import servicesData from "../../Components/Data/ServiceData";

const ServiceSection = () => {
  const [expandedService, setExpandedService] = useState(null);

  
  return (
    <>
 <PageHeader
  title= "Reach Your Abroad Dream"
subtitle="With Pristine"
  description="Let us guide you every step of the way toward your study abroad dream. With personalized advice and support."
  buttonText="Start Your Journey"
  buttonAction={() => window.location.href = '/abroad-consultancy'}
  backgroundImage="images/service.jpeg"
/>




      <Section>
        <Container>
          <SectionHeader>
            <h2>Our Services</h2>
            <p>
              We offer a wide range of academic, professional, and consultation
              services tailored to your specific needs and goals.
            </p>
          </SectionHeader>
          <ServicesGrid>
            {servicesData.map((service) => (
              <ServiceCard key={service.id}>
                <CardImageWrapper>
                  <CardImage src={service.image} alt={service.title} />
                  <IconWrapper>{service.icon}</IconWrapper>
                </CardImageWrapper>
                <ServiceTitle>{service.title}</ServiceTitle>
                <ServiceDescription>
                  {service.description}
                  {expandedService === service.id && (
                    <span> {service.details}</span>
                  )}
                </ServiceDescription>
                <ButtonGroup>
                 
                  <OrderButton as={Link} to={`/services/${service.id}`}>
                    Read More
                  </OrderButton>
                </ButtonGroup>
              </ServiceCard>
            ))}
          </ServicesGrid>
        </Container>
      </Section>
    </>
  );
};

export default ServiceSection;

// Styled Components
const Section = styled.section`
  padding: 20px 20px;
  background-color: #f2f8f8;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 40px;

  h2 {
    font-size: 2.5rem;
        font-weight: 800;
        color: #333333;
        margin-bottom: 1rem;
        text-transform: uppercase;
        letter-spacing: 1px;

  p {
    color: #333;
    font-size: 1.1rem;
    max-width: 800px;
    margin: 0 auto;
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 1.8rem;
    }

    p {
      font-size: 1rem;
      padding: 0 10px;
    }
  }
`;

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 20px;
`;

const ServiceCard = styled.div`
  background-color: #e6f2f2;
  border-radius: 12px;
  padding: 10px 15px;
  text-align: left;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 15px rgba(0, 0, 0, 0.15);
  }
`;

const CardImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 150px;
  overflow: hidden;
  border-radius: 12px 12px 0 0;
`;

const CardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const IconWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  padding: 10px;
  color: white;
  z-index: 1;

  svg {
    width: 40px;
    height: 40px;
  }
`;

const ServiceTitle = styled.h5`
  color: #023a5b;
  font-size: 1.3rem;
  margin: 15px 0 10px;
`;

const ServiceDescription = styled.p`
  color: #333;
  flex-grow: 1;
  font-size: 0.9rem;
  line-height: 1.6;
  margin-bottom: 30px;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: left;
  gap: 8px;
  margin-top: auto;
`;

const OrderButton = styled.button`
  background-color: #023a5b;
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: #025b50;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(2, 91, 58, 0.3);
  }
`;
